import { wmsApi } from '../../../config/apiClient';
import { ACCOUNTING_API } from '../../../config/api';

export type WmsScreenType = 'picking' | 'packing' | 'receiving' | 'cyclecount';

export interface CreateScreenDto {
  WarehouseId: string;
  Name: string;
  IsActive?: boolean;
  Settings?: string;
}

export interface UpdateScreenDto {
  Id: string;
  Name: string;
  IsActive: boolean;
  Settings?: string;
}

export interface AddCashierDto {
  CashierName: string;
  CashierPin: string;
  CanWmsPicking: boolean;
  CanWmsPacking: boolean;
  CanWmsReceiving: boolean;
  CanWmsCycleCount: boolean;
}

export const screenService = {
  getScreens: (type: WmsScreenType, warehouseId: string) =>
    wmsApi.get(ACCOUNTING_API.WMS_SCREENS(type, warehouseId)),

  getScreenDetail: (type: WmsScreenType, id: string) =>
    wmsApi.get(ACCOUNTING_API.WMS_SCREEN_DETAIL(type, id)),

  createScreen: (type: WmsScreenType, data: CreateScreenDto) =>
    wmsApi.post(ACCOUNTING_API.WMS_SCREEN_CREATE(type), data),

  updateScreen: (type: WmsScreenType, data: UpdateScreenDto) =>
    wmsApi.post(ACCOUNTING_API.WMS_SCREEN_UPDATE(type), data),

  deleteScreen: (type: WmsScreenType, id: string) =>
    wmsApi.post(ACCOUNTING_API.WMS_SCREEN_DELETE(type), { Id: id }),

  getCashiers: (type: WmsScreenType, screenId: string) =>
    wmsApi.get(ACCOUNTING_API.WMS_SCREEN_CASHIERS(type, screenId)),

  addCashier: (type: WmsScreenType, screenId: string, data: AddCashierDto) =>
    wmsApi.post(ACCOUNTING_API.WMS_SCREEN_ADD_CASHIER(type, screenId), data),

  removeCashier: (type: WmsScreenType, screenId: string, cashierId: number) =>
    wmsApi.post(ACCOUNTING_API.WMS_SCREEN_REMOVE_CASHIER(type, screenId), { CashierId: cashierId }),
};
